import React from "react";
import { useSelector } from "react-redux";
import {
  makeStyles,
  Grid,
  Typography,
  Box,
  Button,
  Divider,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import { commonService } from "../../../../services/common.service";
import { adminService } from "../../../../services/admin.service";
import { grey100 } from "material-ui/styles/colors";
import { Skeleton } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import { withStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { trackingrequest } from "../service/service";
import { getBase64 } from "../service/service";

export const CustomDropZone = withStyles((theme) => ({
  textContainer: {
    color: theme.palette.ePastelColor2?.base,
  },
  text: {
    margin: "2% 0% 0.8% 0%",
    color: theme.palette.ePrimary?.base,
    fontSize: "0.75rem",
  },
  icon: {
    color: theme.palette.ePrimary?.base,
    marginBottom: "1.5%",
  },
  root: {
    marginTop: "1%",
    minHeight: "55%",
    width: "75%",
    align: "center",
  },
}))(DropzoneArea);
const useStyle = makeStyles((theme) => ({
  image: {
    margin: "1rem",
  },
  box: {
    justify: "center",
    backgroundColor: grey100,
    border: "1px dashed" + theme?.palette?.eRich?.base,
    margin: "1rem",
  },
  technicalLabel: {
    fontWeight: "bold",
  },
  inProgressLabel: {
    color: theme?.palette?.eTertiary?.base,
    fontWeight: "bold",
  },
  content: {
    margin: "2rem",
  },
  revistContent: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    margin: "1rem",
  },
  error: {
    color: theme?.palette?.eDanger?.dark,
  },
  previewChip: {
    paddingTop: "2% !important",
    paddingBottom: "1% !important",
    wordWrap: "break-word !important",
    whiteSpace: "normal !important",
  },
  hr: {
    width: "75%",
    color: theme?.palette?.ePrimary?.base + "!important",
    fontWeight: "bold",
    marginLeft: "13%",
    height: "2px",
  },
  paymentButton: {
    backgroundColor: theme?.palette?.eSecondary?.base,
    color: theme?.palette?.eWhite?.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary?.hover,
      color: theme?.palette?.eWhite?.base,
    },
  },
  marginButton: {
    marginRight: "6%",
    marginTop: "2%",
  },
}));

export default function EDropzone({
  selectedFiles,
  index,
  setSelectedFiles,
  fileName,
  attachmentId,
  attachmentFor,
  reset
}) {
  const { enqueueSnackbar } = useSnackbar();
  let labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_STREET_LIGHT_SERVICE
  );

  const [fileData, setFileData] = useState();
  const trackClass = useStyle();

  const [fileTypes, setFileTypes] = useState([]);
  let DUPLICATE_FILE_MESSAGE = useSelector(
    (state) =>
      state?.labels?.data?.getLabels?.E_SUPPORT_COMPLAINTS
        ?.E_COMPLAINTS_DUPLICATE_FILES_ERROR
  );
  const MAX_FILE_SIZE = parseInt(
    useSelector((state) => state?.parametersWidgets?.ParameterLookup?.MAX_SIZE)
  );
  let MAX_FILES_ALLOWED_MESSAGE =
    labels?.E_STREET_LIGHT_REQUEST_MAX_FILES_ERROR;
  let MAX_FILES_ALLOWED_PARAMETER = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.SERVICE_REQUEST_MAX_FILES_ALLOWED);
  MAX_FILES_ALLOWED_MESSAGE = MAX_FILES_ALLOWED_MESSAGE?.replaceAll(
    "**",
    MAX_FILES_ALLOWED_PARAMETER
  );
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const [tempFileData, setTempData] = useState([]);
  const [key, setKey] = useState(0);
    useEffect(()=>{
      if(reset){
      setSelectedFiles([])
      setKey(key + 1);
    }
    },[reset])
  const onchangeSelectedfile = (fileData, fileName) => {
    let temp = selectedFiles.filter((item)=>{
      if(item.attachmentFor !== fileData.attachmentFor){
        return item
      }
    })
    setSelectedFiles([...temp, fileData]);
  };

  const handleFileChange = (files) => {
  let apidata = {};
  let filesupload = {};

    files.forEach((file) => {
      getBase64(file).then((data) => {
        apidata["fileType"] = file.name.substring(file.name.lastIndexOf(".")+1);
        apidata["fileName"] = file.name.replace(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/, "");
        apidata["fileContent"] = data.split(';base64,')[1];
        apidata["attachmentFor"]=attachmentFor;   
       
        setTempData(apidata);
        filesupload && onchangeSelectedfile(apidata);
      });
    });
    setFileData(tempFileData);
   
  };
  useEffect(() => {
    if (!fileTypes.length) {
      trackingrequest.getFileTypes(languageCode).then((res) => {
        let fileTypes = [];
        res.data.fileTypes.forEach((k) => {
          fileTypes.push("." + k.FileAttachmentTypeCode.toLowerCase());
        });
        setFileTypes(fileTypes);
      });
    }
  }, []);
  const idFile = selectedFiles.map((item)=>{
    return item
  })
  const fileformateTypes = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_NCR_FILE_FORMATS
  );
const onDelete = (files) => {
  let tempArray = []  
    idFile.map((item)=>{
    const deletedFile = item?.attachmentFor
    const tempFile = fileName
      if(tempFile && tempFile !== deletedFile){
        tempArray.push(item)
      }
    })
    setSelectedFiles(tempArray)
  }
  return (
    <>
      <CustomDropZone
        dropzoneText={labels?.E_STREET_LIGHT_REQUEST_DROP_ZONE_HELP_TEXT}
        previewChipProps={{ trackClass: { label: trackClass.previewChip } }}
        value={selectedFiles}
        key={key}
        onChange={handleFileChange}
        filesLimit={1 - selectedFiles.length}
        showFileNames
        showAlerts={['success']}
        maxFileSize={MAX_FILE_SIZE * 1000000}
        acceptedFiles={fileformateTypes?.split(",")}
        useChipsForPreview
        onAlert={(msg, variant) => variant !== "success" && enqueueSnackbar(msg, { variant: variant })}
        onchangeSelectedfile={onchangeSelectedfile}
        onDelete={onDelete}
      />
    </>
  );
}
